import React, { useState, useEffect, useCallback } from 'react';

// Extrai data/hora local diretamente do texto (evita ambiguidade de fuso do
// Date() do navegador com os formatos que vêm do backend, já em hora local).
const fmtDateTime = (raw) => {
  if (!raw) return '';
  const m = /(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(raw);
  if (!m) return '';
  const [, , mo, d, h, mi] = m;
  return `${d}/${mo} ${h}:${mi}`;
};

function AITab({ svc }) {
  const [analise, setAnalise] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await svc.getAnalise();
      setAnalise(d);
    } catch (e) { /* silêncio */ } finally { setLoading(false); }
  }, [svc]);

  useEffect(() => { load(); }, [load]);

  const runAgora = async () => {
    setBusy(true);
    try {
      const d = await svc.getAnalise(true);
      setAnalise(d);
    } catch (e) { /* silêncio */ } finally { setBusy(false); }
  };

  if (loading) return <div className="wk-view"><p className="wk-msg">Carregando…</p></div>;

  return (
    <div className="wk-view">
      <section className="card analise-card">
        <div className="analise-head">
          <h3>🧠 Análise de IA</h3>
          <button className="analise-refresh" onClick={runAgora} disabled={busy}>
            {busy ? '…' : 'Nova análise'}
          </button>
        </div>
        {analise?.error && (
          <p className="wk-msg wk-err">{analise.error}</p>
        )}
        {analise?.analise && (
          <>
            {analise.gerado_em && (
              <div className="analise-timestamp">Gerada em {fmtDateTime(analise.gerado_em)}</div>
            )}
            <div className="analise-text">{analise.analise.replace(/\*\*/g, '')}</div>
          </>
        )}
        {!analise?.analise && !analise?.error && (
          <p className="wk-msg">Sem dados suficientes ainda pra gerar a análise.</p>
        )}
      </section>
      <div className="wk-spacer" />
    </div>
  );
}

export default AITab;
